import { Injectable } from '@angular/core';
import type { Erp1cOperationTypeFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/erp-1c-operation-type/erp-1c-operation-type-find-many-query.dto';
import type { Erp1cOperationTypeSyncQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/erp-1c-operation-type/erp-1c-operation-type-sync-query.dto';
import type { Erp1cOperationTypePageInterface } from '@zaoblako/shared/modules/catalog/dtos/erp-1c-operation-type/erp-1c-operation-type-page.dto';
import type { Erp1cOperationTypeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/erp-1c-operation-type/erp-1c-operation-type-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Erp1cOperationTypeService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/erp-1c-operation-type';

  public findWithPagination(
    queryParams?: Erp1cOperationTypeFindManyQueryInterface
  ): Observable<Erp1cOperationTypePageInterface> {
    return this.http.get<Erp1cOperationTypePageInterface>(this.baseUrl, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public restoreOne(id: number): Observable<Erp1cOperationTypeFindInterface> {
    return this.http.post<Erp1cOperationTypeFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public synchronizeBy1c(queryParams?: Erp1cOperationTypeSyncQueryInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/synchronize-by-1c`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
